// Numéro de version de l'interface, remplacé à la construction par Vite
// (`define` dans vite.config.ts, lu dans web/package.json).
declare const __APP_VERSION__: string;

export const APP_VERSION: string = __APP_VERSION__;
